import React from 'react';
import { Trash2 } from 'lucide-react';

const sel = 'h-9 w-full rounded-lg border border-gray-300 bg-white px-2 text-xs disabled:opacity-60';

export const RigaAttivita = ({ a, frequenze, tipi, prodotti, modificabile, onCambia, onElimina }) => {
  const delTipo = prodotti.filter((p) => p.tipo === a.tipo_prodotto);
  return (
    <li className="py-2.5 border-b border-gray-200 last:border-0" data-testid={`pulizie-piano-riga-${a.id}`}>
      <div className="flex items-start justify-between gap-2">
        <span className="text-sm text-gray-900">{a.attivita}</span>
        {modificabile && (
          <button onClick={() => onElimina(a)} className="p-1 text-gray-400 hover:text-red-600" aria-label="Togli attività"
            data-testid={`pulizie-piano-elimina-${a.id}`}>
            <Trash2 className="h-4 w-4" />
          </button>
        )}
      </div>
      <div className="mt-1.5 grid grid-cols-2 gap-2">
        <select value={a.frequenza} disabled={!modificabile} onChange={(e) => onCambia(a, { frequenza: e.target.value })}
          className={sel} data-testid={`pulizie-piano-freq-${a.id}`}>
          {Object.entries(frequenze).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </select>
        <select value={a.tipo_prodotto} disabled={!modificabile} onChange={(e) => onCambia(a, { tipo_prodotto: e.target.value })}
          className={sel} data-testid={`pulizie-piano-tipo-${a.id}`}>
          {Object.entries(tipi).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </select>
      </div>
      {delTipo.length > 0 ? (
        <select value={a.prodotto || ''} disabled={!modificabile} onChange={(e) => onCambia(a, { prodotto: e.target.value })}
          className={`${sel} mt-2`} data-testid={`pulizie-piano-prodotto-${a.id}`}>
          <option value="">Automatico: gli ultimi acquistati</option>
          {delTipo.map((p) => <option key={p.nome} value={p.nome}>{p.nome}</option>)}
        </select>
      ) : a.tipo_prodotto !== 'nessuno' && (
        <p className="mt-1 text-xs text-gray-500">Nessun prodotto di questo tipo nelle fatture</p>
      )}
    </li>
  );
};
